import { Enum } from 'enumify';

class CcBannerAreaCode extends Enum {
	get label (): string {
		return 'enum_bannerarea_'.concat(this.name.concat('_label'));
	}
}

CcBannerAreaCode.initEnum(['homepage', 'homepageMobile', 'homepagePrivate', 'homepageMobilePrivate', 'products', 'registration']);
export default CcBannerAreaCode;
